import React, { Component } from "react";
import { alertActions } from 'redux/actions/alert-actions';
import { connect } from 'react-redux';

class MessagePage extends Component {
	constructor(props) {
	    super(props);

	    this.errorMessage = this.errorMessage.bind(this);
	    this.ClearAfterSomeTime = this.ClearAfterSomeTime.bind(this);

	}

	ClearAfterSomeTime(){
      const { dispatch } = this.props;
      setTimeout( function()
      {
          dispatch(alertActions.clear());
      } ,
      4000);
  }
  serverFormValidation(data) {
      const valItems  = Object.keys(data).map(x=> {
          return (data[x].map((y,i)=> {

                  return (<li key={i}>{y}</li>)
              })
          )
      });
      return valItems;
  }
  errorMessage() {
      const alert=this.props.alert;

      if (typeof alert.message === 'string'){

          const valDiv = <div className={`alert ${alert.type} mt-10`}><div className="simpleErrorNew">{alert.message}</div></div>;
          this.ClearAfterSomeTime();
          return valDiv;
      }

      if (typeof alert.message === 'object'){
          const valDiv = <div className={`alert ${alert.type} mt-10`}><div className="validationError"><ul>{this.serverFormValidation(alert.message)}</ul></div></div>;
          this.ClearAfterSomeTime();
          return valDiv;
      }
  }

  render(){
  	const { alert } = this.props;
  	return(
  		<div className="message" id="alert">
          { alert.message ? this.errorMessage(alert):'' }
      	</div>
  	);
  }
}


function mapStateToProps(state) {
    const { alert } = state;
    const typeOfAlert = typeof alert.message;
    return {
        alert,
        typeOfAlert
    };
}

const MessageCom = connect(mapStateToProps)(MessagePage);

export default MessageCom;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Message.jsx